import { DateTime } from 'luxon';
import md5 from 'md5';
import React from 'react';
import { useSelector } from 'react-redux';
import ConfermaBTN from '../../../components/ConfermaBTN/ConfermaBTN';

function RecapLettura({data}) {
    const pod = useSelector((user) => user.user.currentPod.podCode)
    const address = useSelector((user) => user.user.currentPod.podAddress)
    const city = useSelector((user) => user.user.currentPod.podCity)
    const customerId = useSelector((user) => user.user.info.customer_id)
    const podCode = useSelector((user) => user.user.info.pod_code);
    const podId = useSelector((user) => user.user.info.pod_id)
    const tknPvt = md5(customerId + 'oYmAIdtki%lu')
    const url = `https://my.revoluce.it/area_utente/gestione/api/deliveries/setAutolettura.php?tkn_pvt=${tknPvt}&customer_id=${customerId}&f1=${data.a1}&f2=${data.a2}&f3=${data.a3}&codice_pod=${podCode}&pod_id=${podId}&data_consumo=${data.data}`
    return (
        <div className="recap">
            <div className="text">
                <p className="main">Invio autolettura</p>
                <div className="box">
                    <p>Puoi inviarci l'autolettura nel periodo di tempo che va dal 28 al 3 di ogni mese.</p>
                </div>
            </div>
            <div className="customRow">
                <div className="item">
                    <p className="label">POD</p>
                    <p className="value">{pod && pod}</p>
                </div>
                <div className="item">
                    <p className="label">Data</p>
                    <p className="value">{DateTime.fromISO(data.data).toFormat('D')}</p>
                </div>
            </div>
            <div className="customRow">
                <div className="item">
                    <p className="label">Utenza</p>
                    <p className="value">{address}</p>
                </div>
                <div className="item">
                    <p className="label">Città</p>
                    <p className="value">{city}</p>
                </div>
            </div>
            <div className="customRow data">
                <div className="item">
                    <p className="label">F1</p>
                    <p className="value">{data.a1}</p>
                </div>
                <div className="item">
                    <p className="label">F2</p>
                    <p className="value">{data.a2}</p>
                </div>
                <div className="item">
                    <p className="label">F3</p>
                    <p className="value">{data.a3}</p>
                </div>
            </div>
            <ConfermaBTN text="Invia autolettura" confermTxt={`Confermi la lettura ${data.a1} - ${data.a2} - ${data.a3} del ${DateTime.fromISO(data.data).toFormat('D')} ?`} url={url} forward={'/enrica/richiesta-inoltrata'} type="letture"/>
            {/* <SwiperButtonGen text={'Invia autolettura'} data={data} url={url} forward={'/enrica/richiesta-inoltrata'}/> */}
        </div>
    );
}

export default RecapLettura;
